/**
 * DirectionsService geocodes origin/destination strings. Bare US ZIPs like
 * "84065" often return NOT_FOUND (ambiguous / non-US). Append ", USA" and pair
 * with DirectionsRequest.region = "us" (ccTLD bias) per Maps JS docs.
 *
 * https://developers.google.com/maps/documentation/javascript/legacy/directions
 */
export function formatUsZipForDirections(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) {
    return trimmed;
  }
  if (/,\s*USA$/i.test(trimmed)) {
    return trimmed;
  }
  // 5-digit or ZIP+4
  if (/^\d{5}(-\d{4})?$/.test(trimmed)) {
    return `${trimmed}, USA`;
  }
  return trimmed;
}
